import axios from "axios";

const instance = axios.create({ timeout: 10000 });

//#region 통신모음

//BLO 통신
const soap = async (actionName, params, webserviceUrl) => {
  try {
    const xml = makeXML(actionName, params);
    const response = await instance.post(webserviceUrl, xml, {
      headers: {
        "Content-Type": "text/xml; charset=utf-8",
        SOAPAction: `http://tempuri.org/${actionName}`
      }
    });
    const oParser = new DOMParser();
    const oDOM = oParser.parseFromString(response.data, "text/xml");
    const result = oDOM.querySelector(`${actionName}Result`);
    const json = XmlToJson(result);
    return json;
  } catch (e) {
    console.error(e);
    if (e.response) {
      const reason = getErrorMessage(e.response.data);
      if (reason) {
        //alert(reason);
      }
    }
  }
};

// SOAP 통신 리턴받은 XML형식 데이터를 JSON 구조로 파싱
const XmlToJson = result => {
  if (result == null) {
    //void형
    return "";
  }
  if (result.children.length > 0) {
    const data = [];
    const nds = result.querySelector("NewDataSet"); //이부분은 개발하면서 확인필요!!
    //const ds = result.querySelectorAll("TblCache");
    //console.log(ds.length);
    const ds = nds.querySelectorAll("Table");
    //console.log(result.querySelectorAll("ListCache")[0].children);
    if (ds.length > 0) {
      //Dataset
      for (var table of ds) {
        const obj = {};
        for (var col of table.children) {
          //배열들어가있으면 요쪽에서 다시처리해줘야될듯
          obj[col.tagName.toLowerCase()] = col.textContent;
        }
        data.push(obj);
      }
      return data;
    }
    const strArr = result.querySelectorAll("string");
    if (strArr.length > 0) {
      //string 배열 ex) catalogservice MarcGet
      for (var str of strArr) {
        data.push(str.textContent);
      }
      return data;
    }

    return data;
  } else {
    //string
    return typeof result.textContent === "string"
      ? result.textContent
      : "error";
  }
};

//XML 에러메세지 파싱
const getErrorMessage = data => {
  const oParser = new DOMParser();
  const oDOM = oParser.parseFromString(data, "text/xml");
  let reason = oDOM.querySelector("faultstring")
    ? oDOM.querySelector("faultstring").textContent
    : "";
  if (reason) {
    return reason;
  }
  reason = oDOM.querySelector("Text")
    ? oDOM.querySelector("Text").textContent
    : "";
  if (reason) {
    return reason;
  }
};

const makeXML = (actionName, valArr) => {
  let content = "";
  for (const [key, value] of Object.entries(valArr)) {
    //console.log(valArr);
    switch (typeof value) {
      case "string":
        //parameter 가 문자열일 경우
        content += `<${key}>${value ? value : ""}</${key}>`;
        break;
      case "boolean":
      case "number":
        //parameter가 bool,number일 경우
        content += `<${key}>${value}</${key}>`;
        break;
      case "object":
        if (Array.isArray(value)) {
          //parameter 가 배열일 경우 string 배열만 처리되어있음 필요시 추가작업필요
          content += `<${key}>`;
          for (const item of value) {
            if (typeof item === "string") {
              //string 일경우
              content += `<string>${item ? item : ""}</string>`;
            }
          }
          content += `</${key}>`;
        }
        break;
      default:
        break;
    }
  }
  const xml = `<s:Envelope xmlns:s="http://schemas.xmlsoap.org/soap/envelope/">
  <s:Body xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema">
    <${actionName} xmlns="http://tempuri.org/">
          ${content}
    </${actionName}>
  </s:Body>
</s:Envelope>`;
  return xml;
};

//#endregion 통신모음

const argumentCheck = args => {
  for (const arg of args) {
    if (arg) {
      return arg + " required";
    }
  }
  return "";
};

export { soap };
